import { saveCommandingOptions } from './saveCommandingOptions';

export function saveRibbonOWAMSITExperimentToolbarUserOption(
    ribbonOWAMSITExperimentToolbarUser: boolean
) {
    saveCommandingOptions({ ribbonOWAMSITExperimentToolbarUser });
}
